import { Link } from 'react-router-dom'
import cn from 'classnames'
import Icon, { IconName } from '../Common/Icon'
import IconButton from '../Common/IconButton'
import Text from '../Common/Text'
import styles from './ArcPresence.module.scss'

export enum ArcActivityTone {
  Working = 'working',
  Done = 'done',
  Stopped = 'stopped',
}

const TONE_CLASS: Record<ArcActivityTone, string> = {
  [ArcActivityTone.Working]: styles.cardWorking,
  [ArcActivityTone.Done]: styles.cardDone,
  [ArcActivityTone.Stopped]: styles.cardStopped,
}

interface IProps {
  icon: IconName
  tone?: ArcActivityTone
  title: string
  status?: string
  link?: string | null
  onDismiss?: () => void
}

/** One thing Arc is doing or just did, at the rail's shared width whatever its source. */
const ArcActivityCard = ({ icon, tone, title, status, link, onDismiss }: IProps) => (
  <li className={cn(styles.card, tone && TONE_CLASS[tone])}>
    <Icon name={icon} size="sm" className={styles.cardIcon} />
    <Text
      variant="body"
      casing="none"
      tone="primary"
      component="span"
      className={styles.cardTitle}
      title={title}
    >
      {title}
    </Text>
    {status && (
      <Text variant="bodySm" casing="role" component="span" className={styles.cardStatus}>
        {status}
      </Text>
    )}
    {link && (
      <Link to={link} className={styles.cardLink} onClick={onDismiss}>
        View
      </Link>
    )}
    {onDismiss && (
      <IconButton title="Dismiss" box="sm" onClick={onDismiss}>
        <Icon name="x" size="xs" />
      </IconButton>
    )}
  </li>
)

export default ArcActivityCard
